import { GameGenre } from "../Game";
import { ProfileType } from "../User";

export class MockGameGenre implements GameGenre {
  private static INDEX = 0;

  public id: string;
  public title = "title";
  public uuid: string;
  public userProfiles?: ProfileType[];

  constructor() {
    MockGameGenre.INDEX++;
    this.id = `${MockGameGenre.INDEX}`;
    this.uuid = `${MockGameGenre.INDEX}`;
    this.userProfiles = [
      ProfileType.GENERIC,
      ProfileType.KIDS,
      ProfileType.TEENS,
      ProfileType.PRE_TEENS,
    ];
  }
}
